import { render, staticRenderFns } from "./sendOrder.vue?vue&type=template&id=c4ee256c&scoped=true"
import script from "./sendOrder.vue?vue&type=script&lang=js"
export * from "./sendOrder.vue?vue&type=script&lang=js"
import style0 from "./sendOrder.vue?vue&type=style&index=0&id=c4ee256c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ee256c",
  null
  
)

export default component.exports